import React from "react";

const LoadingComponent = () => (
  <div className="text-center">
    <div className="spinner-border"></div>
  </div>
);

export default LoadingComponent;
